/**
 * Loading Spinner
 * Componentization of https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/atoms/loading-spinners
 */
/** imports */
import * as React from 'react';
import * as styles from './styles';
import * as typestyle from 'typestyle';
import * as csstips from 'csstips';

export namespace LoaderStyles {
  const spinnerRotate = typestyle.keyframes({
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  })

  const base = {
    display: 'inline-block',
    background: 'transparent',

    /** Set it up with a side missing */
    color: styles.colors.red,
    borderStyle: 'solid',
    broderTopColor: 'currentColor',
    broderLeftColor: 'currentColor',
    broderRightColor: 'currentColor',
    borderBottomColor: 'transparent',

    /** Setup to be a circle */
    borderRadius: '100%',

    /** Animation */
    animation: `${spinnerRotate} .75s linear infinite`,
  }

  export const rootClassName = typestyle.style(base, {
    width: '20px',
    height: '20px',
    borderWidth: '2px',
  });

  export const rootWhiteClassName = typestyle.style(base, {
    width: '20px',
    height: '20px',
    borderWidth: '3px',
    color: 'white',
  });

  export const centerCenter = typestyle.style(csstips.centerCenter);
}

/** Reusable simple loader */
export const Loader = ({}) => {
  return <div className={LoaderStyles.rootClassName}></div>
}

export const LoaderWhite = ({}) => {
  return <div className={LoaderStyles.rootWhiteClassName}></div>
}

/**
 * Big loader wrapped up in a div and centered
 */
export const SectionLoader = ({}) => {
  return <div className={LoaderStyles.centerCenter}><Loader/></div>;
}

namespace ProgressBarStyles {
  export const rootClassName = typestyle.style(
    csstips.flexRoot,
    csstips.flex,
    {
      backgroundColor: styles.colors.warmGrey2,
      position: 'relative',
      /** to allow placing easily in centered content */
      width: '100%',
      /** to match text height */
      height: '18px',
    });
  export const doneSectionClassName = typestyle.style({
    backgroundColor: styles.colors.red,
    transition: 'width .4s'
  });
}

/**
 * A full width progress bar
 */
export const ProgressBar = ({percent}: {percent: number}) => {
  return <div className={ProgressBarStyles.rootClassName}>
    <div className={ProgressBarStyles.doneSectionClassName} style={{width: `${percent}%`}}>
      &nbsp;
    </div>
  </div>
}
